import type { Testimonial } from '@/types/content';

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '夏栀',
    role: '追综五年 · 资深观众',
    avatarText: '夏',
    rating: 5,
    quote:
      '最舒服的一点是它不急着下结论。同一个话题会标注更新时间，前面写过什么、后来怎么变的都留在页面上，看完不会一头雾水。',
  },
  {
    id: 't-2',
    name: '老陈看剧',
    role: '影视区内容创作者',
    avatarText: '陈',
    rating: 5,
    quote:
      '找素材的时候经常来这里翻时间线，分类做得很细，综艺和影视分开看，省了很多自己拼信息的时间。',
  },
  {
    id: 't-3',
    name: '一颗小柚子',
    role: '短视频剪辑爱好者',
    avatarText: '柚',
    rating: 4,
    quote:
      '首屏的实时上新真的有毒，打开就想看看又更了什么。排版干净，手机上刷起来也不累眼。',
  },
  {
    id: 't-4',
    name: '阿泽',
    role: '娱乐行业从业者',
    avatarText: '泽',
    rating: 5,
    quote:
      '行业风云这个栏目我几乎每篇都看，从宣发节奏到平台生态，写得克制又有信息量，不像有些地方全靠标题。',
  },
  {
    id: 't-5',
    name: '午夜放映厅',
    role: '影评专栏作者',
    avatarText: '午',
    rating: 5,
    quote:
      '口碑分化的话题整理得很有条理，正反两方观点分开列，不会只挑刺激的那一面说，这点很难得。',
  },
  {
    id: 't-6',
    name: '栗子同学',
    role: '大三学生',
    avatarText: '栗',
    rating: 4,
    quote:
      '搜索和分类筛选很好用，想看什么类型直接点标签就行。希望以后能加上收藏功能。',
  },
];